import { render, staticRenderFns } from "./PrestarAtencion.vue?vue&type=template&id=58eb5398&scoped=true&"
import script from "./PrestarAtencion.vue?vue&type=script&lang=js&"
export * from "./PrestarAtencion.vue?vue&type=script&lang=js&"
import style0 from "./PrestarAtencion.vue?vue&type=style&index=0&id=58eb5398&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb5398",
  null
  
)

export default component.exports